import React from 'react';
import { useState } from 'react';
import PopUpDropzone from './PupUpDropzone';
import Button from '../Button';
import { TYPE_BUTTONS } from '../../../../constans';

const FileDropzone = ({ onClickLoad = () => {}, ...props }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div style={{ minWidth: '200px' }}>
      <Button type={TYPE_BUTTONS.BLUE} onClick={() => setIsOpen(true)}>
        Подгрузить фото
      </Button>

      {isOpen && (
        <PopUpDropzone
          close={() => setIsOpen(false)}
          onClickLoad={(f) => {
            onClickLoad(f);
            setIsOpen(false);
          }}
        />
      )}
    </div>
  );
};

export default FileDropzone;
